import type { RootState } from '@/store/store';

export const selectScriptsSettings = (state: RootState) => state.pages.currentPage?.scriptsSettings;
